import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import "./styles/ProduccionReportada.css";

class ProduccionReportada extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    navigateToPaletizaciones = () => {
        this.props.history.push(`/produccion-v2/paletizaciones`);
    };

    navigateToCierreTurno = () => {
        this.props.history.push(`/produccion-v2/cierre-turno?doubleregreso=true`);
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Producción Sólidos"
                    subtitulo="Reportar producción"
                    noBorder
                >
                    <Listado
                        regresar={this.regresar}
                        navigateToPaletizaciones={this.navigateToPaletizaciones}
                        navigateToCierreTurno={this.navigateToCierreTurno}
                    />
                </Card>
            </div>
        );
    }
}

export default ProduccionReportada;
